import { render, staticRenderFns } from "./Tokyo.vue?vue&type=template&id=318d730b&"
import script from "./Tokyo.vue?vue&type=script&lang=js&"
export * from "./Tokyo.vue?vue&type=script&lang=js&"
import style0 from "./Tokyo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports